import { DialogProps } from '@mui/material'

/**
 * `sx` that stretches a UA Insights Dialog's paper to the full viewport-
 * allowed height (`calc(100% - 64px)`) so every dialog in the feature renders
 * at the same, predictable, large size regardless of content length.
 *
 * Applied via the Dialog's `sx` (not `PaperProps`) because targeting the
 * `.MuiDialog-paper` class yields more reliable specificity than merging into
 * Paper's own sx, especially alongside MUI's built-in `maxHeight` rule.
 *
 * Keeping the paper always full-height also means the loading spinner stays
 * vertically centred and the dialog does not visibly resize when data arrives
 * or when an in-place refetch (e.g. network-filter change) completes.
 */
export const fullHeightDialogSx: DialogProps['sx'] = {
  '& .MuiDialog-paper': {
    height: 'calc(100% - 64px)',
  },
}
